import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";
import CreateSlug from "./extra/CreateSlug";

const Footer = () => {
  const navigate = useNavigate();

  const { Headers, isHeader, cartItems, AllProducts, AllCategoriess, LocationHeaders, IsUserData } =
    useBlogContext();
  const filteredLocations = LocationHeaders;



  return (
    <>

      <footer className="site-footer bg-white  style-1">
        {/* Footer Top */}
        <div className="footer-top">
          <div className="container">
            <div className="row">


              {isHeader
                ? // Skeleton columns
                Array.from({ length: 1 }).map((_, index) => (
                  <div
                    className="col-xl-2 col-md-4 col-sm-4 col-6 wow fadeInUp"
                    key={index}
                  >
                    <div className="widget widget_services">
                      <div
                        className="skeleton mb-3"
                        style={{ height: 22, width: 120, borderRadius: 5 }}
                      ></div>

                      <ul>
                        {Array.from({ length: 6 }).map((__, i) => (
                          <li key={i}>
                            <div
                              className="skeleton mt-2"
                              style={{ height: 18, width: 90, borderRadius: 5 }}
                            ></div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))
                : Headers?.footer?.map((item, index) => (
                  <div
                    className="col-xl-3 col-md-4 col-sm-4 col-6 wow fadeInUp"
                    key={index}
                  >
                    <div className="widget widget_services">
                      <h5 className="footer-title ">{item.text}</h5>

                      <ul>
                        {item.children.map((child, i) => (
                          <li key={i}>
                            <Link to={child.link}>{child.text}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}



              <div
                className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp"

              >
                <div className="widget widget_about me-2">
                  <div className="footer-logo logo-white">
                    {/* <Link to="/">
                      <img src={`${Headers.meta_favicon}`} alt="" style={{ maxHeight: 60 }} />
                    </Link> */}
                  </div>
                  <ul className="widget-address mt-0">
                    <li>
                      <p>
                        <span className="fw-bold">Address</span> : {Headers.address}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span className="fw-bold">E-mail</span> : {Headers.email}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span className="fw-bold">Phone</span> : {Headers.phone}
                      </p>
                    </li>
                  </ul>

                </div>
              </div>




            </div>
          </div>
        </div>
        {/* Footer Top End */}
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            <div
              className="row fb-inner wow fadeInUp"
              data-wow-delay="0.1s"
              style={{
                visibility: "visible",
                animationDelay: "0.1s",
                animationName: "fadeInUp"
              }}
            >
              <div className="col-lg-6 col-md-12 text-start">

                <p className="copyright-text">
                  {!isHeader && Headers.footer_credit}
                </p>
              </div>
              <div className="col-lg-6 col-md-12 text-end">
                <div className="d-flex align-items-center justify-content-center justify-content-md-center justify-content-xl-end">
                  <span className="me-3">We Accept: </span>
                  <img src="/assets/img/footer-img.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Bottom End */}
      </footer>

    </>
  );
};

export default Footer;
